import React from 'react';
import { Header as HeaderDS } from '@soluto-design/react';
import cls from '@soluto-design/styles/cls';

interface SimpleHeaderProps {
    className?: string;
    theme?: string;
}

const SimpleHeader = ({ className, theme }: SimpleHeaderProps) => {
    return (
        <HeaderDS
            sticky
            {...(theme && { 'data-theme': theme })}
            variant="simple"
            classes={{
                root: cls([
                    'py-xg inset-x-0 bg-transparent transition-all duration-300 ease-in-out header--variant-simple',
                    className,
                ]),
                wrapper: cls('flex-1 !items-start container'),
                children: cls('flex-1 !items-start overflow-hidden '),
            }}
            iconLink={{
                href: '/',
            }}
        />
    );
};

export default SimpleHeader;
